export default "<div class=\"typeDechetRW\">\n    {{TypeInComponent?.Code}}\n</div>";